import React from "react";

import moment from "moment";

import Select from "react-select";

import Slider, { Range } from "rc-slider";

import { Button, ButtonGroup, Dropdown, Accordion } from "aible";
import { Popover, OverlayTrigger, Modal } from "react-bootstrap";
import Toggle from "react-toggle";

import { isEnabled } from "utils/featureFlags";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCog,
  faChevronLeft,
  faThumbsUp,
  faThumbsDown,
  faTrash,
  faEdit,
  faArrowAltCircleUp,
  faArrowAltCircleDown,
  faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";

import NumericLabel from "react-pretty-numbers";

import { LineInput } from "components/Inputs/LineInput";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import Waterfall from "components/Waterfall/Waterfall";

import ImpactSlider from "components/Optimizer/ImpactSlider";
import CostsWaterfall from "components/Costs/Waterfall/CostsWaterfall";

import ProjectTitle from "components/UnifiedProject/ProjectTitle";
import ProjectHelpContainer from "containers/UnifiedProject/Help/ProjectHelp";
import ProjectHelpItem from "components/UnifiedProject/Help/ProjectHelpItem";

import ModelBoxContainer from "containers/Business/ModelBox/ModelBox";
import BaselineCostsContainer from "containers/UnifiedProject/RealityCheck/BaselineCosts";

import CurrentStateContainer from "containers/CurrentState/CurrentState";
import { AIBLE_VIEW_TYPE, isSameSetup } from "containers/Project/reducer";

import { checkValueWarning, getWarningMessage } from "containers/Setup/reducer";

import numeral from "numeral";

import RefreshIcon from "images/refreshB.svg";
import PurpleMind from "images/PurpleMind.svg";
import PurpleTarget from "images/PurpleTarget.svg";
import PurpleWarning from "images/PurpleWarning.svg";

import styles from "./style.module.css";

export const PROJECT_MODES = {
  OVERALL: "Overall",
  DRILLDOWN: "Drilldown",
  VIEW_SEGMENTS: "View Subgroups"
};

const numberFormatParams = {
  shortFormat: true,
  shortFormatMinValue: 0,
  precision: 1,
  justification: "L",
  locales: "en-US"
};

export default class RealityCheck extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { countType: "SOME" };
  }

  componentDidUpdate(prevProps, prevState) {
    const { setup } = this.props;
    if (setup && prevProps && prevProps.setup) {
      if (setup.showImpact && !prevProps.setup.showImpact && this.impactRef) {
        this.impactRef.scrollIntoView({ behavior: "smooth", block: "start" });
      } else if (setup.showBusiness && !prevProps.setup.showBusiness && this.businessRef) {
        this.businessRef.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }

  getLabelFromSegment(segment) {
    return segment.conditions.length === 0 ? "Overall" : segment.conditions[0].value;
  }

  getIsOverallSegment() {
    const { project, optimized } = this.props;

    return (
      optimized &&
      optimized.innerSegment &&
      optimized.innerSegment.conditions.length === 0 &&
      optimized.innerSegment.job &&
      optimized.innerSegment.job.job_id === optimized.innerId &&
      project &&
      project.segments &&
      project.segments.length > 1
    );
  }

  renderAllBox() {
    const {
      id,
      setup,
      runId,
      updatePursuedCount,
      updateNotPursuedCount,
      updatePursuedRatio,
      updateNotPursuedRatio,

      transactionLabel,
      outcomeLabel,
      notPursuedTransactionLabel,
      trueAction,
      falseAction,
      unitType
    } = this.props;

    const truePositive = setup.baselineCounts ? Number(setup.baselineCounts.truePositive) : Number(setup.truePositive);
    const falsePositive = setup.baselineCounts
      ? Number(setup.baselineCounts.falsePositive)
      : Number(setup.falsePositive);
    const trueNegative = setup.baselineCounts ? Number(setup.baselineCounts.trueNegative) : Number(setup.trueNegative);
    const falseNegative = setup.baselineCounts
      ? Number(setup.baselineCounts.falseNegative)
      : Number(setup.falseNegative);

    const pursued = truePositive + falsePositive;
    const notPursued = trueNegative + falseNegative;

    const baselineTotal = pursued + notPursued;

    const baselinePositives = truePositive + falseNegative;
    const baselineNegatives = falsePositive + trueNegative;

    const positives = Number(setup.truePositive) + Number(setup.falseNegative);
    const negatives = Number(setup.falsePositive) + Number(setup.trueNegative);

    const total = positives + negatives;

    const totalWinRate = ((positives / (positives + negatives)) * 100).toFixed(2);

    const notPursusedWinRate =
      falseNegative + trueNegative === 0 ? 0 : ((falseNegative / (falseNegative + trueNegative)) * 100).toFixed(2);

    const winRate =
      truePositive + falsePositive === 0 ? 0 : ((truePositive / (truePositive + falsePositive)) * 100).toFixed(2);

    return (
      <div className={styles.realityBox} style={{ marginTop: "0px", maxWidth: "400px" }}>
        <div className={styles.bold}>{"Aible will try to reduce the " + transactionLabel + " you " + trueAction}</div>
        <div>
          <span>{"Since you do not "}</span>
          <span className={styles.bold}>{falseAction}</span>
          <span>{" any "}</span>
          <span className={styles.bold}>{notPursuedTransactionLabel}</span>
          <span>{" (you "}</span>
          <span className={styles.bold}>{trueAction}</span>
          <span>{" all "}</span>
          <span className={styles.bold}>{transactionLabel}</span>
          <span>{") Aible will identify "}</span>
          <span className={styles.bold}>{notPursuedTransactionLabel}</span>
          <span>{" to "}</span>
          <span className={styles.bold}>{falseAction}</span>
        </div>
      </div>
    );
  }

  renderNoneBox() {
    const {
      id,
      setup,
      runId,
      updatePursuedCount,
      updateNotPursuedCount,
      updatePursuedRatio,
      updateNotPursuedRatio,

      transactionLabel,
      outcomeLabel,
      notPursuedTransactionLabel,
      trueAction,
      falseAction,
      unitType
    } = this.props;

    const truePositive = setup.baselineCounts ? Number(setup.baselineCounts.truePositive) : Number(setup.truePositive);
    const falsePositive = setup.baselineCounts
      ? Number(setup.baselineCounts.falsePositive)
      : Number(setup.falsePositive);
    const trueNegative = setup.baselineCounts ? Number(setup.baselineCounts.trueNegative) : Number(setup.trueNegative);
    const falseNegative = setup.baselineCounts
      ? Number(setup.baselineCounts.falseNegative)
      : Number(setup.falseNegative);

    const pursued = truePositive + falsePositive;
    const notPursued = trueNegative + falseNegative;

    const baselineTotal = pursued + notPursued;

    const baselinePositives = truePositive + falseNegative;
    const baselineNegatives = falsePositive + trueNegative;

    const positives = Number(setup.truePositive) + Number(setup.falseNegative);
    const negatives = Number(setup.falsePositive) + Number(setup.trueNegative);

    const total = positives + negatives;

    const totalWinRate = ((positives / (positives + negatives)) * 100).toFixed(2);

    const notPursusedWinRate =
      falseNegative + trueNegative === 0 ? 0 : ((falseNegative / (falseNegative + trueNegative)) * 100).toFixed(2);

    const winRate =
      truePositive + falsePositive === 0 ? 0 : ((truePositive / (truePositive + falsePositive)) * 100).toFixed(2);

    return (
      <div className={styles.realityBox} style={{ marginTop: "0px", maxWidth: "400px" }}>
        <div className={styles.bold}>
          {"Aible will try to identify worthwhile " + transactionLabel + " to " + trueAction}
        </div>
        <div>
          <span>{"Since you do not "}</span>
          <span className={styles.bold}>{trueAction}</span>
          <span>{" any "}</span>
          <span className={styles.bold}>{transactionLabel}</span>
          <span>{" (you "}</span>
          <span className={styles.bold}>{falseAction}</span>
          <span>{" all "}</span>
          <span className={styles.bold}>{notPursuedTransactionLabel}</span>
          <span>{") Aible will identify "}</span>
          <span className={styles.bold}>{transactionLabel}</span>
          <span>{" to "}</span>
          <span className={styles.bold}>{trueAction}</span>
        </div>
      </div>
    );
  }

  renderRealityBox() {
    const {
      id,
      setup,
      runId,
      updatePursuedCount,
      updateNotPursuedCount,
      updatePursuedRatio,
      updateNotPursuedRatio,

      transactionLabel,
      outcomeLabel,
      notPursuedTransactionLabel,
      trueAction,
      falseAction,
      unitType
    } = this.props;

    const truePositive = setup.baselineCounts
      ? Math.round(setup.baselineCounts.truePositive)
      : Math.round(setup.truePositive);
    const falsePositive = setup.baselineCounts
      ? Math.round(setup.baselineCounts.falsePositive)
      : Math.round(setup.falsePositive);
    const trueNegative = setup.baselineCounts
      ? Math.round(setup.baselineCounts.trueNegative)
      : Math.round(setup.trueNegative);
    const falseNegative = setup.baselineCounts
      ? Math.round(setup.baselineCounts.falseNegative)
      : Math.round(setup.falseNegative);

    const pursued = truePositive + falsePositive;
    const notPursued = trueNegative + falseNegative;

    const baselineTotal = pursued + notPursued;

    const baselinePositives = truePositive + falseNegative;
    const baselineNegatives = falsePositive + trueNegative;

    const positives = Math.round(setup.truePositive) + Math.round(setup.falseNegative);
    const negatives = Math.round(setup.falsePositive) + Math.round(setup.trueNegative);

    const total = positives + negatives;

    const totalWinRate = ((positives / (positives + negatives)) * 100).toFixed(2);

    const notPursusedWinRate =
      falseNegative + trueNegative === 0 ? 0 : ((falseNegative / (falseNegative + trueNegative)) * 100).toFixed(2);

    const winRate =
      truePositive + falsePositive === 0 ? 0 : ((truePositive / (truePositive + falsePositive)) * 100).toFixed(2);

    return (positives === baselinePositives && negatives === baselineNegatives) ||
      (setup && setup.isRealityHammer === false) ? (
      <div />
    ) : (
      <div className={styles.realityBox} style={{ marginTop: "0px", maxWidth: "400px" }}>
        <div className={styles.bold}>{"Adjusted by Behavior Assumptions"}</div>
        <div>
          <span>{"Scenario adjusted "}</span>
          <span>{" by " + (positives > baselinePositives ? " adding " : " removing ")}</span>
          <span className={styles.bold}>
            {Math.abs(positives - baselinePositives) + " potential " + transactionLabel + " likely to " + outcomeLabel}
          </span>
          <span>{" and by " + (negatives > baselineNegatives ? " adding " : " removing ")}</span>
          <span className={styles.bold}>
            {Math.abs(negatives - baselineNegatives) +
              " potential " +
              transactionLabel +
              " unlikely to " +
              outcomeLabel}
          </span>
        </div>
      </div>
    );
  }

  renderWaterfall() {
    const {
      id,
      setup,
      runId,
      isEditBlueprint,
      updatePursuedCount,
      updateNotPursuedCount,
      updatePursuedRatio,
      updateNotPursuedRatio,

      transactionLabel,
      outcomeLabel,
      notPursuedTransactionLabel,
      trueAction,
      falseAction,
      unitType
    } = this.props;

    const truePositive =
      setup.isRealityHammer && setup.baselineCounts
        ? Number(setup.baselineCounts.truePositive)
        : Number(setup.truePositive);
    const falsePositive =
      setup.isRealityHammer && setup.baselineCounts
        ? Number(setup.baselineCounts.falsePositive)
        : Number(setup.falsePositive);
    const trueNegative =
      setup.isRealityHammer && setup.baselineCounts
        ? Number(setup.baselineCounts.trueNegative)
        : Number(setup.trueNegative);
    const falseNegative =
      setup.isRealityHammer && setup.baselineCounts
        ? Number(setup.baselineCounts.falseNegative)
        : Number(setup.falseNegative);

    const pursued = truePositive + falsePositive;
    const notPursued = trueNegative + falseNegative;

    const baselineTotal = pursued + notPursued;

    const positives = Number(setup.truePositive) + Number(setup.falseNegative);
    const negatives = Number(setup.falsePositive) + Number(setup.trueNegative);

    const bPositives = truePositive + falseNegative;
    const bNegatives = falsePositive + trueNegative;

    const baselinePositives = truePositive + falseNegative;
    const baselineNegatives = falsePositive + trueNegative;

    const total = positives + negatives;

    const totalWinRate = ((positives / (positives + negatives)) * 100).toFixed(2);

    const baselineTotalWinRate = ((bPositives / (bPositives + bNegatives)) * 100).toFixed(2);

    const notPursusedWinRate =
      falseNegative + trueNegative === 0 ? 0 : ((falseNegative / (falseNegative + trueNegative)) * 100).toFixed(2);

    const winRate =
      truePositive + falsePositive === 0 ? 0 : ((truePositive / (truePositive + falsePositive)) * 100).toFixed(2);

    const isEditDisabled = isEditBlueprint !== true && this.getIsOverallSegment();

    return (
      <div className={styles.rWaterfall}>
        <div className={styles.waterfallLeft}>
          <div className={styles.wQuestion}>
            {"How many"}
            <span className={styles.rBold}>{transactionLabel + " "}</span>
            <span>{" do you"}</span>
            <span className={styles.rBold}>{trueAction}</span>
            <span>{"?"}</span>
            <div className={styles.wInput}>
              <LineInput
                isMediumBox
                value={pursued}
                onChange={(val) => updatePursuedCount(val.replace(/,/g, ""))}
                isDisabled={isEditDisabled}
              />
              <div style={{ marginRight: "15px" }}>{" with a "}</div>
              <div style={{ width: "80px" }}>
                <LineInput
                  isMediumBox
                  value={winRate}
                  onChange={(val) => updatePursuedRatio(val)}
                  isDisabled={isEditDisabled}
                />
              </div>
              <div style={{ marginLeft: "-6px" }}>{"% potential " + outcomeLabel + " rate"}</div>
            </div>
          </div>
          <div className={styles.wQuestion}>
            {"How many"}
            <span className={styles.rBold}>{notPursuedTransactionLabel + " "}</span>
            <span>{" do you"}</span>
            <span className={styles.rBold}>{falseAction}</span>
            <span>{"?"}</span>
            <div className={styles.wInput}>
              <LineInput
                isMediumBox
                value={notPursued}
                onChange={(val) => updateNotPursuedCount(val.replace(/,/g, ""))}
                isDisabled={isEditDisabled}
              />
              <div style={{ marginRight: "15px" }}>{" with a "}</div>
              <div style={{ width: "80px" }}>
                <LineInput
                  isMediumBox
                  value={notPursusedWinRate}
                  onChange={(val) => updateNotPursuedRatio(val)}
                  isDisabled={isEditDisabled}
                />
              </div>
              <div style={{ marginLeft: "-6px" }}>{"% potential " + outcomeLabel + " rate"}</div>
            </div>
          </div>
          <div className={styles.wQuestion}>
            <span style={{ fontWeight: "bold" }}>{"Baseline " + notPursuedTransactionLabel}</span>
            <div className={styles.wInput}>
              <LineInput isMediumBox value={baselineTotal} isDisabled />
              <div style={{ marginRight: "15px" }}>{" with a "}</div>
              <div style={{ width: "80px" }}>
                <LineInput isMediumBox value={baselineTotalWinRate} isDisabled />
              </div>
              <div style={{ marginLeft: "-6px" }}>{"% potential " + outcomeLabel + " rate"}</div>
            </div>
          </div>
        </div>
        <div className={styles.waterfallRight}>
          <CostsWaterfall setup={setup} showAbsTotal={true} />
        </div>
      </div>
    );
  }

  getIsNumerical(dataset) {
    return (
      dataset &&
      dataset.outcome &&
      dataset.fields &&
      dataset.fields[dataset.outcome] &&
      dataset.fields[dataset.outcome].type === "number"
    );
  }

  renderNumerical() {
    const {
      setup,
      madLibs,
      updateMadLibs,
      updateTransactionLabel,
      updateUnitType,

      transactionLabel,
      outcomeLabel,
      notPursuedTransactionLabel,
      trueAction,
      falseAction,
      unitType
    } = this.props;

    return (
      <div className={styles.realityHolder}>
        <div style={{ padding: "20px", paddingBottom: "0px" }}>{this.renderHelp()}</div>
        <div className={styles.realityMid}>
          <div className={styles.smallTitle} style={{ marginBottom: "0px" }}>
            {"What business terms would you like to use?"}
          </div>
          <div className={styles.cBox}>
            {"Customizing the businesss language here allows Aible to explain " +
              "the insights, predictions and recommendations in your own terms."}
          </div>
          <div className={styles.rMidInfo}>
            <div className={styles.lineInputWidth}>
              <LineInput
                isMediumBox
                labelStyle={{ color: "#4B495B" }}
                topLabel={"The transactions represent"}
                value={transactionLabel}
                onChange={(val) => updateTransactionLabel(val)}
              />
            </div>
            <div className={styles.lineInputWidth}>
              <LineInput
                isMediumBox
                labelStyle={{ color: "#4B495B" }}
                topLabel={"The number predicted is the"}
                value={madLibs ? madLibs.numberPredicted : ""}
                onChange={(val) => updateMadLibs("numberPredicted", val)}
              />
            </div>
            {/* <div className={styles.lineInputWidth}>
              <LineInput
                isMediumBox
                labelStyle={{ color: "#4B495B" }}
                topLabel={
                  <div>
                    <span>{"I want to optimize the Price of "}</span>
                    <span style={{ fontWeight: "bold" }}>
                      {transactionLabel}
                    </span>
                  </div>
                }
                value={madLibs ? madLibs.contAction : ""}
                onChange={(val) => updateMadLibs("contAction", val)}
              />
            </div> */}
            <div className={styles.lineInputWidth}>
              <LineInput
                isMediumBox
                labelStyle={{ color: "#4B495B" }}
                topLabel={"The unit of measure is (USD, hours, etc.)"}
                value={setup.unitType !== undefined ? setup.unitType : "$"}
                onChange={(val) => updateUnitType(val)}
              />
            </div>
          </div>
          <div className={styles.rMidInfo} style={{ marginTop: "20px" }}>
            <div className={styles.lineInputWidth}>
              <LineInput
                isMediumBox
                labelStyle={{ color: "#4B495B" }}
                topLabel={"A prediction that is too low causes"}
                value={madLibs ? madLibs.underPredictAction : ""}
                onChange={(val) => updateMadLibs("underPredictAction", val)}
              />
            </div>
            <div className={styles.lineInputWidth}>
              <LineInput
                isMediumBox
                labelStyle={{ color: "#4B495B" }}
                topLabel={"A prediction that is too high causes"}
                value={madLibs ? madLibs.overPredictAction : ""}
                onChange={(val) => updateMadLibs("overPredictAction", val)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderHelp() {
    const {} = this.props;
    return (
      <ProjectHelpContainer title={"Validate Expected Behavior"} subtitle={"Why are we asking these questions?"}>
        <ProjectHelpItem type={"mind"}>
          {"Adding business terms improves the clarity " + "of the insights, predictions and recommendations."}
        </ProjectHelpItem>
        <ProjectHelpItem type={"target"}>
          {"Validating the behavior ensures that " + "the AI is trained on an expected reality."}
        </ProjectHelpItem>
        <ProjectHelpItem type={"warning"}>
          {"If the data doesnt reflect reality, which is a common problem in AI tools, " +
            "the AI will attempt to optimize for an incorrect goal."}
        </ProjectHelpItem>
      </ProjectHelpContainer>
    );
  }

  /*

  <div>
  <span>{"of my " + transactionLabel + " each"}</span>
  <span
    style={{
      width: "200px",
      marginLeft: "10px",
      marginRight: "10px",
    }}
  >
    <Select
      options={[
        { value: "Month", label: "Month" },
        { value: "Day", label: "Day" },
        { value: "Week", label: "Week" },
        { value: "Quarter", label: "Quarter" },
        { value: "Year", label: "Year" },
      ]}
      defaultValue={[{ value: "Month", label: "Month" }]}
      styles={{
        menu: provided => ({
          ...provided,
          zIndex: 200
        })
      }}
    />
  </span>
  </div>

  */

  renderEditBlueprint() {
    const { runId, setup, project } = this.props;

    return (
      <AdvancedCostsContainer
        id={runId}
        runId={runId}
        blueprintId={setup && setup.blueprintId ? setup.blueprintId : "newBlueprint"}
        projectId={project ? project.id : undefined}
        isOptimizer
      />
    );
  }

  renderCustomCosts() {
    const {
      id,
      runId,
      setup,
      optimized,
      blueprint,
      customMappings,
      updateTotal,
      updateConversionGain,
      updateConversionCost,
      updateCustomValue
    } = this.props;

    const retId = optimized && optimized.innerId !== undefined ? optimized.innerId : id;

    return (
      <div className={styles.costsHolder}>
        <div className={styles.aHolder}>
          <div className={styles.assumptionEditItem}>
            <div className={styles.costEditThirdsOne} style={optimized === undefined ? { width: "50%" } : {}}>
              {"Counts"}
            </div>
            <div className={styles.costEditThirdsThree}>
              <div className={styles.cFieldInput}>
                <LineInput
                  isMediumBox
                  value={setup.truePositive + setup.falsePositive + setup.trueNegative + setup.falseNegative}
                  onChange={(val) => updateTotal(val)}
                />
              </div>
            </div>
          </div>
          {Object.keys(setup.customValues).map((v, i) => {
            const showWarning =
              optimized &&
              optimized.setup &&
              optimized.setup.customValues &&
              optimized.originalSetup &&
              optimized.originalSetup.customValues
                ? checkValueWarning(optimized.setup.customValues[v], optimized.originalSetup.customValues[v])
                : false;

            const bpDesc =
              blueprint &&
              blueprint &&
              blueprint.wizard &&
              blueprint.wizard.customFields &&
              blueprint.wizard.customFields[v] &&
              blueprint.wizard.customFields[v].desc
                ? blueprint.wizard.customFields[v].desc
                : v;

            const currMapping = customMappings && customMappings[v];

            return (
              <React.Fragment key={v + i}>
                <div className={styles.assumptionEditItem}>
                  <div className={styles.costEditThirdsOne} style={optimized === undefined ? { width: "50%" } : {}}>
                    <OverlayTrigger
                      placement={"top"}
                      trigger={["hover", "focus"]}
                      containerPadding={20}
                      overlay={<Popover id={"popover-positioned-top"}>{bpDesc}</Popover>}
                    >
                      <span>{v}</span>
                    </OverlayTrigger>
                  </div>
                  <div className={styles.costEditThirdsThree}>
                    <div className={styles.cFieldInput}>
                      <LineInput
                        isMediumBox
                        onChange={(val) => updateCustomValue(runId, setup.blueprintId, v, val)}
                        value={setup.customValues[v]}
                        style={{ color: "#4B495B" }}
                        isWarning={showWarning}
                        warning={
                          showWarning &&
                          getWarningMessage(
                            optimized.setup.customValues[v],
                            optimized.originalSetup.customValues[v],
                            "Scenario",
                            "Blueprint"
                          )
                        }
                      />
                    </div>
                  </div>
                </div>
              </React.Fragment>
            );
          })}
        </div>
      </div>
    );
  }

  renderCosts() {
    const {
      setup,
      optimized,
      updateTotal,
      updateConversionGain,
      updateConversionCost,
      updateConversionSaved,
      updateConversionMissed,
      blueprint
    } = this.props;

    const hasCustomValues =
      blueprint &&
      blueprint.wizard &&
      blueprint.wizard.customFields &&
      Object.keys(blueprint.wizard.customFields).length > 0;

    return hasCustomValues ? (
      this.renderCustomCosts()
    ) : (
      <div className={styles.costsHolder}>
        <div className={styles.costOption}>
          <div className={styles.cLabel}>{"Counts"}</div>
          <div className={styles.cOpt}>
            <LineInput
              isMediumBox
              value={setup.truePositive + setup.falsePositive + setup.trueNegative + setup.falseNegative}
              onChange={(val) => updateTotal(val)}
            />
          </div>
        </div>
        <div className={styles.costOption}>
          <div className={styles.cLabel}>{setup.truePositiveLabel}</div>
          <div className={styles.cOpt}>
            <LineInput isMediumBox value={setup.conversionGain} onChange={(val) => updateConversionGain(val)} />
          </div>
        </div>
        <div className={styles.costOption}>
          <div className={styles.cLabel}>{setup.falsePositiveLabel}</div>
          <div className={styles.cOpt}>
            <LineInput isMediumBox value={setup.conversionCost} onChange={(val) => updateConversionCost(val)} />
          </div>
        </div>
        <div className={styles.costOption}>
          <div className={styles.cLabel}>{setup.trueNegativeLabel}</div>
          <div className={styles.cOpt}>
            <LineInput isMediumBox value={setup.conversionSaved} onChange={(val) => updateConversionSaved(val)} />
          </div>
        </div>
        <div className={styles.costOption}>
          <div className={styles.cLabel}>{setup.falseNegativeLabel}</div>
          <div className={styles.cOpt}>
            <LineInput isMediumBox value={setup.conversionMissed} onChange={(val) => updateConversionMissed(val)} />
          </div>
        </div>
      </div>
    );
  }

  renderSliders() {
    const {
      updateCountType,
      updatePursuedRatio,
      updateNotPursuedRatio,
      updateTryRatio,
      updateBudgetRange,
      setup,
      transactionLabel,
      outcomeLabel,
      notPursuedTransactionLabel,
      trueAction,
      falseAction,
      unitType
    } = this.props;

    const { countType, cTryRatio, cPursuedRatio, cNotPursuedRatio } = this.state;

    const pursuedRatio = setup.pursuedRatio
      ? setup.pursuedRatio
      : (setup.truePositive / (setup.truePositive + setup.falsePositive)) * 100;

    const notPursuedRatio = setup.notPursuedRatio ? setup.notPursuedRatio : pursuedRatio;
    //setup.falseNegative === 0 && setup.trueNegative === 0
    //? pursuedRatio
    //: (setup.falseNegative / (setup.trueNegative + setup.falseNegative)) * 100;

    const tryRatio = (
      ((setup.truePositive + setup.falsePositive) /
        (setup.truePositive + setup.falsePositive + setup.trueNegative + setup.falseNegative)) *
      100
    ).toFixed(2);

    const nPRatio = notPursuedRatio === 0 ? 100 : notPursuedRatio;

    return (
      <div className={styles.realityBot}>
        <div className={styles.businessBot}>
          {/*
          {"The training data I provided reflects"}
          <div className={styles.aRadio}>
            <input
              type="radio"
              checked={countType === "ALL"}
              onClick={() => this.setState({ countType: "ALL" })}
            />
            <div className={styles.aRadioLabel}>
              {"only " + notPursuedTransactionLabel + " I pursue today."}
            </div>
          </div>
          <div className={styles.aRadio}>
            <input
              type="radio"
              checked={countType === "SOME"}
              onClick={() => this.setState({ countType: "SOME" })}
            />
            <div className={styles.aRadioLabel}>
              {"also includes " + transactionLabel + " I don't pursue"}
            </div>
          </div>
        */}
          <div className={styles.aSlider}>
            <div className={styles.aSliderLabel} style={{ width: "100%" }}>
              <span style={{ fontWeight: "bold" }}>
                <input
                  value={cTryRatio !== undefined ? cTryRatio : tryRatio}
                  onChange={(e) => this.setState({ cTryRatio: e.target.value })}
                  onBlur={(e) => updateTryRatio(e.target.value)}
                />
              </span>
            </div>
            <div className={styles.aSliderBody}>
              <Slider
                type="range"
                min={0}
                max={100}
                onChange={(e) => this.setState({ cTryRatio: e })}
                onAfterChange={(e) => updateTryRatio(e)}
                defaultValue={tryRatio}
                value={cTryRatio || tryRatio}
                step={0.01}
                trackStyle={{ backgroundColor: "#7E69D7" }}
                handleStyle={{
                  backgroundColor: "#7E69D7",
                  borderColor: "white",
                  boxShadow: "0px 0px 6px 1px rgba(81, 47, 119, 0.35)"
                }}
              />
            </div>
          </div>
          <div className={styles.aSlider}>
            <div className={styles.aSliderLabel}>
              <span style={{ fontWeight: "bold", width: "100%" }}>
                <input
                  value={
                    cPursuedRatio !== undefined
                      ? Math.round(cPursuedRatio)
                      : pursuedRatio
                        ? Math.round(pursuedRatio)
                        : `0`
                  }
                  onChange={(e) => this.setState({ cPursuedRatio: e.target.value })}
                  onBlur={(e) => updatePursuedRatio(e.target.value)}
                />
              </span>
              {/*
              <span>{" (In data "}</span>
              <span style={{ fontWeight: "bold" }}>{"10%"}</span>
              {")"}
              */}
            </div>
            <div className={styles.aSliderBody}>
              <Slider
                type="range"
                min={0}
                max={100}
                onChange={(e) => this.setState({ cPursuedRatio: e })}
                onAfterChange={(e) => updatePursuedRatio(e)}
                defaultValue={Math.round(pursuedRatio)}
                value={cPursuedRatio || Math.round(pursuedRatio)}
                step={0.01}
                trackStyle={{ backgroundColor: "#7E69D7" }}
                handleStyle={{
                  backgroundColor: "#7E69D7",
                  borderColor: "white",
                  boxShadow: "0px 0px 6px 1px rgba(81, 47, 119, 0.35)"
                }}
              />
            </div>
          </div>
          <div className={styles.aSlider}>
            <div className={styles.aSliderLabel}>
              <span style={{ fontWeight: "bold" }}>
                <input
                  value={cNotPursuedRatio !== undefined ? Math.round(cNotPursuedRatio) : Math.round(notPursuedRatio)}
                  onChange={(e) => this.setState({ cNotPursuedRatio: e.target.value })}
                  onBlur={(e) => updateNotPursuedRatio(e.target.value)}
                />
              </span>
            </div>
            <div className={styles.aSliderBody}>
              <Slider
                type="range"
                min={0}
                max={100}
                onChange={(e) => this.setState({ cNotPursuedRatio: e })}
                onAfterChange={(e) => updateNotPursuedRatio(e)}
                defaultValue={notPursuedRatio}
                value={cNotPursuedRatio || notPursuedRatio}
                step={0.01}
                trackStyle={{ backgroundColor: "#7E69D7" }}
                handleStyle={{
                  backgroundColor: "#7E69D7",
                  borderColor: "white",
                  boxShadow: "0px 0px 6px 1px rgba(81, 47, 119, 0.35)"
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderAssumptions() {
    const {
      id,
      setup,
      blueprint,
      optimizer,
      optimized,
      isContinuous,
      customMappings,
      toggleCustomMapping,
      modelGroups,
      updateBaselineCustomValue,
      updateCustomValue,
      updateDrilldownValue,
      canEditAssumptions,
      updateConversionGain,
      updateConversionCost,
      updateConversionSaved,
      updateConversionMissed,
      updateBaselineConversionGain,
      updateBaselineConversionCost,
      updateBaselineConversionMissed,
      updateBaselineConversionSaved
    } = this.props;

    if (setup === undefined || Object.keys(setup).length === 0) {
      return <div />;
    }

    const retId = optimized && optimized.innerId !== undefined ? optimized.innerId : id;

    const hasCustomValues =
      optimized &&
      optimized.setup &&
      optimized.setup.customValues &&
      Object.keys(optimized.setup.customValues).length > 0;

    const showCustomValues = hasCustomValues;

    return (
      <div>
        <div className={styles.shareHeader}>
          <div className={styles.costSectionOne} style={{ paddingLeft: "0px" }}>
            {"Assumptions"}
          </div>
          <div className={styles.costSectionTwo}>{"Distribution"}</div>
          <div className={styles.costSectionThree} style={{ paddingRight: "0px" }}>
            {"Average"}
          </div>
        </div>
        {showCustomValues ? (
          <div
            className={styles.oItemBotContent}
            style={{
              marginTop: "0px"
            }}
          >
            <div className={styles.aholder}>
              {Object.keys(optimized.setup.customValues).map((c, i) => {
                const bpDesc =
                  optimized &&
                  optimized.blueprint &&
                  optimized.blueprint &&
                  optimized.blueprint.wizard &&
                  optimized.blueprint.wizard.customFields &&
                  optimized.blueprint.wizard.customFields[c] &&
                  optimized.blueprint.wizard.customFields[c].desc
                    ? optimized.blueprint.wizard.customFields[c].desc
                    : c;

                return (
                  <div key={i} className={styles.assumptionItem}>
                    <div className={styles.costSectionOne} title={bpDesc}>
                      {c}
                    </div>
                    <div className={styles.costSectionTwo}>
                      <ImpactSlider
                        impacts={modelGroups.drilldownValues.map((v) => ({
                          value: v.setup.customValues[c],
                          drilldownValue: v.value,
                          runId: v.runId,
                          color: v.color
                        }))}
                        currentImpact={optimized.setup.customValues[c]}
                        drilldownValue={optimizer.drilldownValue}
                        updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                      />
                    </div>
                    <div className={styles.costSectionThree}>
                      {optimized.setup.customValues[c] !== undefined
                        ? Number(optimized.setup.customValues[c]).toFixed(2)
                        : ""}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <div>
            {modelGroups && modelGroups.drilldownValues && (
              <div
                className={styles.oItemBotContent}
                style={{
                  marginTop: "0px"
                }}
              >
                <div className={styles.assumptionItem}>
                  <div className={styles.costSectionOne}>{optimized.setup.truePositiveLabel}</div>
                  <div className={styles.costSectionTwo}>
                    <ImpactSlider
                      impacts={modelGroups.drilldownValues.map((v) => ({
                        value: v.setup.conversionGain,
                        drilldownValue: v.value,
                        runId: v.runId,
                        color: v.color
                      }))}
                      currentImpact={optimized.setup.conversionGain}
                      drilldownValue={optimizer.drilldownValue}
                      updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                    />
                  </div>
                  <div className={styles.costSectionThree}>
                    {optimized.setup.conversionGain !== undefined
                      ? Number(optimized.setup.conversionGain).toFixed(2)
                      : ""}
                  </div>
                </div>
                <div className={styles.assumptionItem}>
                  <div className={styles.costSectionOne}>{optimized.setup.falsePositiveLabel}</div>
                  <div className={styles.costSectionTwo}>
                    <ImpactSlider
                      impacts={modelGroups.drilldownValues.map((v) => ({
                        value: v.setup.conversionCost,
                        drilldownValue: v.value,
                        runId: v.runId,
                        color: v.color
                      }))}
                      currentImpact={optimized.setup.conversionCost}
                      drilldownValue={optimizer.drilldownValue}
                      updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                    />
                  </div>
                  <div className={styles.costSectionThree}>
                    {optimized.setup.conversionCost !== undefined
                      ? Number(optimized.setup.conversionCost).toFixed(2)
                      : ""}
                  </div>
                </div>
                {!isContinuous ? (
                  <React.Fragment>
                    <div className={styles.assumptionItem}>
                      <div className={styles.costSectionOne}>{optimized.setup.trueNegativeLabel}</div>
                      <div className={styles.costSectionTwo}>
                        <ImpactSlider
                          impacts={modelGroups.drilldownValues.map((v) => ({
                            value: v.setup.conversionSaved,
                            drilldownValue: v.value,
                            runId: v.runId,
                            color: v.color
                          }))}
                          currentImpact={optimized.setup.conversionSaved}
                          drilldownValue={optimizer.drilldownValue}
                          updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                        />
                      </div>
                      <div className={styles.costSectionThree}>
                        {optimized.setup.conversionSaved !== undefined
                          ? Number(optimized.setup.conversionSaved).toFixed(2)
                          : ""}
                      </div>
                    </div>
                    <div className={styles.assumptionItem}>
                      <div className={styles.costSectionOne}>{optimized.setup.falseNegativeLabel}</div>
                      <div className={styles.costSectionTwo}>
                        <ImpactSlider
                          impacts={modelGroups.drilldownValues.map((v) => ({
                            value: v.setup.conversionGain,
                            drilldownValue: v.value,
                            runId: v.runId,
                            color: v.color
                          }))}
                          currentImpact={optimized.setup.conversionMissed}
                          drilldownValue={optimizer.drilldownValue}
                          updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                        />
                      </div>
                      <div className={styles.costSectionThree}>
                        {optimized.setup.conversionMissed !== undefined
                          ? Number(optimized.setup.conversionMissed).toFixed(2)
                          : ""}
                      </div>
                    </div>
                  </React.Fragment>
                ) : (
                  ""
                )}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  render() {
    const {
      id,
      setup,
      dataset,
      optimized,
      isEditBlueprint,
      outcomeWinRate,
      updateOutcomeLabel,
      updateTransactionLabel,
      updateAdvancedRevenueLabel,
      updateNotPursuedTransactionLabel,
      updateTruePositiveLabel,
      updateTrueAction,
      updateFalseAction,
      updateCountType,
      updateUnitType,
      updateShowBusiness,
      updateShowImpact,
      activeSlice,
      transactionLabel,
      outcomeLabel,
      notPursuedTransactionLabel,
      trueAction,
      falseAction,
      unitType,
      runId,
      modelGroups,
      businessAssumptions
    } = this.props;

    const isOverallSegment = this.getIsOverallSegment();

    const isNumerical = this.getIsNumerical(dataset);

    if (isNumerical) {
      return this.renderNumerical();
    }

    const isEditDisabled = isEditBlueprint !== true && this.getIsOverallSegment();

    const TP =
      setup && setup.isRealityHammer && setup.baselineCounts ? setup.baselineCounts.truePositive : setup.truePositive;
    const FP =
      setup && setup.isRealityHammer && setup.baselineCounts ? setup.baselineCounts.falsePositive : setup.falsePositive;
    const FN =
      setup && setup.isRealityHammer && setup.baselineCounts ? setup.baselineCounts.falseNegative : setup.falseNegative;
    const TN =
      setup && setup.isRealityHammer && setup.baselineCounts ? setup.baselineCounts.trueNegative : setup.trueNegative;

    const isAll = Number(TN) + Number(FN) === 0 && Number(setup.truePositive) + Number(FP) > 0;
    const isSome =
      (Number(TN) + Number(FN) > 0 && Number(TP) + Number(FP) > 0) ||
      Number(TP) + Number(FP) + Number(TN) + Number(FN) === 0;
    const isNone = Number(TP) + Number(FP) === 0 && Number(TN) + Number(FN) > 0;

    const currentSegment =
      modelGroups && modelGroups.drilldownValues && modelGroups.drilldownValues.find((group) => group.runId === runId);

    const hasSplits =
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((group) => group.label !== "Overall").length > 0;

    return (
      <div className={styles.realityHolder}>
        <div style={{ height: "30px" }} />
        {hasSplits ? (
          <div
            className={styles.rcHeader}
            style={{
              background: activeSlice.color,
              color: activeSlice && activeSlice.value === "Overall" ? "white" : "#4b495b"
            }}
          >
            {activeSlice && activeSlice.value}
          </div>
        ) : (
          <div className={styles.rcHeader} style={{ height: "0px" }}></div>
        )}
        {/* KEEP THESE, EXPERIMENTAL REMOVAL */}
        {/* <div className={styles.realityMid}>
          <Accordion
            header={
              <div className={styles.smallTitle}>
                {
                  "Please check these descriptions to ensure I can speak your business language"
                }
              </div>
            }
            shrinkHeader
          >
          <div className={styles.rMidInfo} style={{paddingTop: "20px"}}>
            <div className={styles.lineInputWidth}>
              <LineInput
                isMediumBox
                labelStyle={{ color: "#4B495B" }}
                topLabel={"My transactions are called:"}
                defaultValue={transactionLabel}
                onChange={(val) => updateTransactionLabel(val)}
              />
            </div>
            <div className={styles.lineInputWidth}>
              <LineInput
                isMediumBox
                labelStyle={{ color: "#4B495B" }}
                topLabel={"The target outcome is a:"}
                defaultValue={outcomeLabel}
                onChange={(val) => updateOutcomeLabel(val)}
              />
            </div>
            <div className={styles.lineInputWidth}>
              <LineInput
                isMediumBox
                labelStyle={{ color: "#4B495B" }}
                topLabel={
                  <div className={styles.tOverflow}>
                    <span>{"If Aible predicts "}</span>
                    <span style={{ fontWeight: "bold" }}>
                      {outcomeLabel + " "}
                    </span>
                    <span>{"you will"}</span>
                  </div>
                }
                defaultValue={trueAction}
                onChange={(val) => updateTrueAction(val)}
              />
              <div>
                {"the"}
                <span className={styles.rBold}>{transactionLabel}</span>
              </div>
            </div>
            <div className={styles.lineInputWidth}>
              <LineInput
                isMediumBox
                labelStyle={{ color: "#4B495B" }}
                topLabel={
                  <div className={styles.tOverflow}>
                    <span>{"If Aible does not predict "}</span>
                    <span style={{ fontWeight: "bold" }}>
                      {outcomeLabel + " "}
                    </span>
                    <span>{"you will"}</span>
                  </div>
                }
                defaultValue={falseAction}
                onChange={(val) => updateFalseAction(val)}
              />
              <div>
                {"the"}
                <span className={styles.rBold}>
                  {notPursuedTransactionLabel}
                </span>
              </div>
            </div>
            <div className={styles.lineInputWidth}>
              <LineInput
                isMediumBox
                labelStyle={{ color: "#4B495B" }}
                topLabel={
                  <div className={styles.tOverflow}>
                    <span style={{ fontWeight: "bold" }}>
                      {transactionLabel}
                    </span>
                    <span>{" you don't "}</span>
                    <span style={{ fontWeight: "bold" }}>
                      {trueAction}
                    </span>
                    <span>{" are called"}</span>
                  </div>
                }
                value={notPursuedTransactionLabel}
                onChange={(val) => updateNotPursuedTransactionLabel(val)}
              />
            </div>
            <div className={styles.lineInputWidth}>
              <LineInput
                isMediumBox
                labelStyle={{ color: "#4B495B" }}
                topLabel={"The unit of measure is (USD, hours, etc.)"}
                defaultValue={setup.unitType}
                onChange={(val) => updateUnitType(val)}
              />
            </div>
          </div>
          </Accordion>
        </div> */}
        <div className={styles.realSection} ref={(ref) => (this.businessRef = ref)}>
          {this.renderSliders()}
          {this.getIsOverallSegment() !== true && isEnabled("baseline-costs") && (
            <BaselineCostsContainer runId={runId} />
          )}
          {/*<Button
            onClick={() => {
              if (setup.showBusiness) {
                updateShowBusiness(undefined);
                updateShowImpact(undefined);
              } else {
                updateShowBusiness(true);
              }
            }}
          >
            {setup.showBusiness ?  "Hide Business Objective and Context" : "Add Business Objective and Context"}
          </Button>*/}
        </div>

        {!businessAssumptions && (
          <div
            className={styles.realSection}
            ref={(ref) => (this.impactRef = ref)}
            style={{ borderTop: "1px solid rgba(0, 0, 0, 0.2)" }}
          >
            <div className={styles.smallTitle} style={{ marginBottom: "20px" }}>
              {"Maximize your profit and calculate a $ ROI by adding your business drivers and counts"}
            </div>
            {setup.showImpact === true && (false && isOverallSegment ? this.renderAssumptions() : this.renderCosts())}
            <Button
              type={"secondary"}
              onClick={() => {
                if (setup.showImpact) {
                  updateShowImpact(undefined);
                } else {
                  updateShowImpact(true);
                  updateShowBusiness(true);
                }
              }}
            >
              {setup.showImpact ? "Hide Business Drivers" : "Add Business Drivers"}
            </Button>
          </div>
        )}
      </div>
    );
  }
}
